import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "company-text" }
const _hoisted_2 = { class: "dropdown-header" }
const _hoisted_3 = { class: "dropdown-header-content" }
const _hoisted_4 = { class: "user-section" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "drawer-footer-section" }
const _hoisted_7 = {
  key: 0,
  class: "card-header-fixed"
}
const _hoisted_8 = {
  key: 0,
  class: "breadcrumb-section"
}
const _hoisted_9 = { class: "card-content-scrollable" }
const _hoisted_10 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_11 = { class: "d-flex justify-space-between align-center mb-1" }
const _hoisted_12 = { class: "font-weight-medium" }
const _hoisted_13 = { class: "text-caption grey--text" }
const _hoisted_14 = {
  key: 0,
  class: "mt-1 text-caption grey--text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_VBreadcrumbsItem = _resolveComponent("VBreadcrumbsItem")!
  const _component_VBreadcrumbs = _resolveComponent("VBreadcrumbs")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: _ctx.APP_Color,
        elevation: "0",
        height: "56",
        class: "premium-topbar"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawer = !_ctx.drawer)),
            color: "white",
            class: "menu-btn"
          }),
          _createVNode(_component_router_link, {
            to: { path: '/' },
            class: "app-branding",
            onClick: _ctx.goHome
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("span", { class: "brand-text" }, "ERA", -1),
              _createElementVNode("span", { class: "brand-badge" }, "ERP", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_menu, {
            "offset-y": "",
            "max-width": "400"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                variant: "text",
                class: "company-selector",
                "prepend-icon": "mdi-domain"
              }), {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.currentCompanyName), 1),
                  _createVNode(_component_v_icon, {
                    class: "ml-1",
                    size: "18"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-chevron-down", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "company-dropdown",
                elevation: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_icon, {
                        color: "white",
                        size: "20"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("mdi-office-building", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "dropdown-title" }, "Companii", -1))
                    ]),
                    _createVNode(_component_v_chip, {
                      size: "x-small",
                      color: "white",
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.companies.length), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_list, {
                    density: "compact",
                    class: "company-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (c) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: c.ID,
                          onClick: ($event: any) => (_ctx.switchCompany(c)),
                          active: c.ID === _ctx.currentCompanyId,
                          color: _ctx.APP_Color,
                          class: "company-list-item"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_avatar, {
                              color: c.ID === _ctx.currentCompanyId ? _ctx.APP_Color : 'grey-lighten-3',
                              size: "32",
                              class: "company-avatar"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: c.ID === _ctx.currentCompanyId ? 'white' : 'grey-darken-1',
                                  size: "18"
                                }, {
                                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode(" mdi-domain ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["color"])
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ]),
                          append: _withCtx(() => [
                            (c.ID === _ctx.currentCompanyId)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  color: _ctx.APP_Color,
                                  size: "20"
                                }, {
                                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode(" mdi-check-circle ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["color"]))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "company-name" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(c.Name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "active", "color"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_avatar, {
              color: _ctx.APP_Color,
              size: "32"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  size: "18"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-account", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["color"]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Username), 1)
          ]),
          _createVNode(_component_v_chip, {
            color: _ctx.APP_Color,
            variant: "text",
            size: "small",
            class: "version-badge",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAllChangelog = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "12",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-information", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" v" + _toDisplayString(_ctx.APP_Version), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(_component_v_navigation_drawer, {
        app: "",
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.drawer) = $event)),
        color: _ctx.APP_Color,
        theme: "dark",
        elevation: 0,
        permanent: "",
        class: "premium-drawer"
      }, {
        append: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_divider, { class: "footer-divider" }),
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-power-standby",
              title: "Deconectare",
              onClick: _ctx.Logout,
              class: "logout-item"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("mdi-exit-to-app", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            opened: _ctx.open,
            "onUpdate:opened": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.open) = $event)),
            class: "drawer-menu-list"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Menu.filter(x => x.Level == 1), (row) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: row.ID
                }, [
                  (_ctx.Menu.some(x => x.MenuID == row.ID))
                    ? (_openBlock(), _createBlock(_component_v_list_group, {
                        key: 0,
                        "prepend-icon": row.Icon,
                        class: "menu-group-item"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                            title: row.Title,
                            class: "menu-parent-item"
                          }), null, 16, ["title"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Menu.filter(x => x.MenuID == row.ID), (row2) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: row2.ID
                            }, [
                              (_ctx.Menu.some(x => x.MenuID == row2.ID))
                                ? (_openBlock(), _createBlock(_component_v_list_group, {
                                    key: 0,
                                    "no-action": "",
                                    class: "menu-subgroup-item"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                                        title: row2.Title,
                                        class: "menu-child-item"
                                      }), null, 16, ["title"])
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Menu.filter(x => x.MenuID == row2.ID), (row3) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: row3.ID,
                                          title: row3.Title,
                                          onClick: ($event: any) => (_ctx.ShowPage(row3.Title, row3.Url)),
                                          class: "menu-grandchild-item"
                                        }, null, 8, ["title", "onClick"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 1,
                                    title: row2.Title,
                                    onClick: ($event: any) => (_ctx.ShowPage(row2.Title, row2.Url)),
                                    class: "menu-child-item"
                                  }, null, 8, ["title", "onClick"]))
                            ], 64))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["prepend-icon"]))
                    : (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        title: row.Title,
                        "prepend-icon": row.Icon,
                        onClick: ($event: any) => (_ctx.ShowPage(row.Title, row.Url)),
                        class: "menu-single-item"
                      }, null, 8, ["title", "prepend-icon", "onClick"]))
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["opened"])
        ]),
        _: 1
      }, 8, ["modelValue", "color"]),
      _createVNode(_component_v_main, { class: "main-content-area" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "content-container"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "content-card",
                elevation: "8"
              }, {
                default: _withCtx(() => [
                  (!_ctx.$route.path.startsWith('/documente'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_ctx.breadcrumb.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_VBreadcrumbs, {
                                items: _ctx.breadcrumb,
                                class: "breadcrumb-custom"
                              }, {
                                divider: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    color: "grey"
                                  }, {
                                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                      _createTextVNode("mdi-chevron-right", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                item: _withCtx(({ item }) => [
                                  _createVNode(_component_VBreadcrumbsItem, {
                                    link: !!item.url,
                                    style: _normalizeStyle(item.url ? 'cursor: pointer' : ''),
                                    onClick: ($event: any) => (item.url && _ctx.ShowPage(item.title, item.url))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["link", "style", "onClick"])
                                ]),
                                _: 1
                              }, 8, ["items"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_divider, {
                          color: _ctx.APP_Color,
                          class: "header-divider"
                        }, null, 8, ["color"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_router_view, { class: "router-content" })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, { app: "" }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showChangelog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showChangelog) = $event)),
        "max-width": "500px",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h6 d-flex align-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("mdi-new-box", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" Ce e nou în versiunea " + _toDisplayString(_ctx.APP_Version), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (_ctx.latestUpdate[0]?.modules?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Module afectate:", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestUpdate[0].modules, (mod) => {
                          return (_openBlock(), _createBlock(_component_v_chip, {
                            key: mod,
                            small: "",
                            class: "ma-1",
                            color: "primary",
                            "text-color": "white"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(mod), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_v_divider, { class: "my-2" })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.latestUpdate[0]?.description), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    text: "",
                    onClick: _ctx.markAsSeen
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode("Am înțeles", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showAllChangelog,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showAllChangelog) = $event)),
        "max-width": "600px",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h6" }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("Istoricul complet al versiunilor", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, { style: {"max-height":"400px","overflow-y":"auto"} }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changelog, (entry) => {
                    return (_openBlock(), _createBlock(_component_v_sheet, {
                      key: entry.version,
                      class: "pa-3 mb-3 rounded-lg",
                      elevation: "2",
                      color: "grey-lighten-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(entry.version), 1),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatDate(entry.date)), 1)
                        ]),
                        _createElementVNode("div", null, _toDisplayString(entry.description), 1),
                        (entry.modules?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Module: " + _toDisplayString(entry.modules.join(", ")), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    text: "",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAllChangelog = false))
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode("Închide", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}